import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cvaStandaloneTrimSpaces]',
  standalone: false
})
export class CvaTrimSpacesDirective {

  constructor(private readonly el: ElementRef, private readonly control: NgControl) {
  }

  @HostListener('blur') onBlur() {
    const trimmedValue = this.el.nativeElement.value.trim();
    this.el.nativeElement.value = trimmedValue;
    if (this.control) {
      this.control.control?.setValue(trimmedValue);
    }
  }

}
